import React, { useEffect, useState } from "react";
import { Button, Card, Checkbox, DatePicker, Input, notification } from 'antd'
import { CloseOutlined, CaretDownOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'

import './index.scss'

const Filter = (props) => {

    const [tabNo, setTabNo] = useState('Name')
    const [fromDate, setFromDate] = useState(null)
    const [name, setName] = useState('')
    const [alNumber, setAlNumber] = useState('')
    // const [ipNumber, setIpNumber] = useState('')
    const [toDate, setToDate] = useState(null)
    const [status, setStatus] = useState([])
    const [tabs, setTabs] = useState([
        'Name',
        'AL Number',
        // 'IPD Number',
        'Status',
        'Date',
    ])
    const [oldTableParams, setOldTableParams] = useState({})

    useEffect(()=>{
        const tableParams = props.tableParams
        setOldTableParams(tableParams)
    }, [])

    useEffect(()=>{
        if(props.tableParams.searchParams.userName) {
            setName(props.tableParams.searchParams.userName.replace(/%20/g, ' '))
        }
        if(props.tableParams.searchParams.alNumber) {
            setAlNumber(props.tableParams.searchParams.alNumber)
        }
        if(props.tableParams.searchParams.ipNumber) {
            setAlNumber(props.tableParams.searchParams.alNumber)
        }
        // if(props.tableParams.searchParams.ipNumber) {
        //     setIpNumber(props.tableParams.searchParams.ipNumber)
        // }
        if(props.tableParams.filters) {
            if(props.tableParams.filters.date) {
                const dateString = props.tableParams.filters.date
                setFromDate(dateString.split(',')[0])
                setToDate(dateString.split(',')[1])
            }
        }
        if(props.tableParams.searchParams.preAuthStatus) {
            const preAuthStatus = props.tableParams.searchParams.preAuthStatus
            setStatus(preAuthStatus.split(",").map(status => status.replace(/%20/g, ' ')))
        }
    }, [props.tableParams])

    useEffect(() => {
        if (fromDate === null || toDate === null) {
            props.setTableParams({
                ...props.tableParams,
                filters: {
                ...props.tableParams.filters,
                date: ''
                }
            })
        } else {
            props.setTableParams({
                ...props.tableParams,
                filters: {
                ...props.tableParams.filters,
                date: `${dayjs(fromDate).format('YYYY-MM-DD')},${dayjs(toDate).format(
                    'YYYY-MM-DD'
                )}`
                }
            })
        }
    }, [fromDate, toDate])

    const formatName = (name) => {
        const nameParts = name.split(' ');
        const formattedName = nameParts.map(part => encodeURIComponent(part)).join('%20');
        return formattedName;
    }

    const handleReset = () => {
        // props.setTableParams({...oldTableParams})
        // if(props.tableParams.filters.date !== undefined) {
        //     setFromDate(null)
        //     setToDate(null)
        // }
        // if(props.tableParams.searchParams.preAuthStatus !== undefined) {
        //     setStatus([])
        // }
        // if(props.tableParams.searchParams.userName !== undefined) {
        //     setName('')
        // }
        // if(props.tableParams.searchParams.alNumber !== undefined) {
        //     setAlNumber('')
        // }
        // if(props.tableParams.searchParams.ipNumber !== undefined) {
        //     setIpNumber('')
        // }
        setFromDate(null)
        setToDate(null)
        setStatus([])
        setName('')
        setAlNumber('')
        // setIpNumber('')
        props.setTableParams({
            ...props.tableParams,
            filters: {
                ...props.tableParams.filters,
                date: ''
            },
            searchParams: {
                ...props.tableParams.searchParams,
                userName: '',
                alNumber: '',
                ipNumber: '',
                preAuthStatus: ""
            }
        })
    }

    const clearAllFilters = () => {
        setFromDate(null)
        setToDate(null)
        setStatus([])
        setName('')
        setAlNumber('')
        // setIpNumber('')
        props.setTableParams({
            ...props.tableParams,
            filters: {
                ...props.tableParams.filters,
                date: ''
            },
            searchParams: {
                ...props.tableParams.searchParams,
                userName: '',
                alNumber: '',
                ipNumber: '',
                preAuthStatus: ""
            }
        })
    }

    const handleSubmit = () => {
        if (dayjs(toDate).isBefore(dayjs(fromDate))) {
            notification['error']({
                message: 'Invalid Date Range',
                description: 'Please select appropriate date range'
            })
            return
        }
        if((fromDate===null && toDate!==null) || (fromDate!==null && toDate===null)) {
            notification['error']({
                message: 'Invalid Date Range',
                description: 'Please select both date to use date filter'
            })
            return
        }
        props.setTableParams({
            ...props.tableParams,
            page: 1,
            searchParams: {
                ...props.tableParams.searchParams,
                userName: name ? formatName(name) : '',
                alNumber: alNumber ? alNumber : '',
                // ipNumber: ipNumber ? ipNumber : '',
                preAuthStatus: status ? status.join(',').split(' ').join('%20') : ""
            }
        })
        props.handleChange()
        props.closeFunc()
    }

    return (
        <>
            <div style={{
                position: 'fixed',
                top: '0',
                left: '0',
                height: '100vh',
                width: '100vw',
                zIndex: '302',
                background: 'rgba(0, 0, 0, 0.45)'}}
            >
                <Card
                    title={
                        <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                            <span>Filters</span>
                            <CloseOutlined onClick={props.closeFunc}/>
                        </div>
                    }
                    className="filter-card"
                    bodyStyle={{marginTop:'0'}}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '20px', borderBottom: '1px solid lightgray'}}>
                        <span>Filters</span>
                        <span style={{ color: '#eb1212', cursor: 'pointer' }} onClick={clearAllFilters}>Clear All</span>
                    </div>
                    <div className="filters-container">
                        <div className="filter-keys">
                            {tabs.map((tab,idx) => (
                                <span key={idx} onClick={()=>setTabNo(tab)} className={`${tab===tabNo ? 'selected-tab' : ''}`}>
                                    {tab}
                                </span>
                            ))}
                        </div>
                        <div className="filter-data">
                            <div className="filter-name">Search by {tabNo}</div>
                            <div style={{ padding: '15px', height: '200px', overflowY: 'scroll' }}>
                                {tabNo === 'Name' && (
                                    <Input placeholder="Enter Name" className="filter-input"
                                        value={name ? name : undefined}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                )}

                                {tabNo === 'AL Number' && (
                                    <Input placeholder="Enter AL Number" className="filter-input"
                                        value={alNumber ? alNumber : undefined}
                                        onChange={(e) => setAlNumber(e.target.value)}
                                    />
                                )}

                                {/* {tabNo === 'IPD Number' && (
                                    <Input placeholder="Enter IPD Number" className="filter-input"
                                        value={ipNumber}
                                        onChange={(e) => setIpNumber(e.target.value)}
                                    />
                                )} */}

                                {tabNo === 'Status' && (
                                    <Checkbox.Group
                                        options={[
                                            {
                                                label: <span style={{ color: '#2C2B2B', paddingTop: '10px' }}>Insurer Intimations</span>,
                                                value: 'INSURER INTIMATIONS'
                                            },
                                            {
                                                label: <span style={{ color: '#F8991D' }}>Under Process</span>,
                                                value: 'UNDER PROCESS'
                                            },
                                            {
                                                label: <span style={{ color: '#2C2B2B' }}>Discharge Under Review</span>,
                                                value: 'DISCHARGE UNDER REVIEW'
                                            },
                                            {
                                                label: <span style={{ color: '#2C2B2B' }}>Enhancement Received</span>,
                                                value: 'ENHANCEMENT RECEIVED'
                                            },
                                            {
                                                label: <span style={{ color: '#B4C4E1' }}>Initial Pending</span>,
                                                value: 'INITIAL PENDING'
                                            },
                                            {
                                                label: <span style={{ color: '#0075DB' }}>Initial Approved</span>,
                                                value: 'INITIAL APPROVED'
                                            },
                                            {
                                                label: <span style={{ color: '#627FB5' }}>Queried</span>,
                                                value: 'QUERIED'
                                            },
                                            {
                                                label: <span style={{ color: '#9747FF' }}>Query Received</span>,
                                                value: 'QUERY RECEIVED'
                                            },
                                            {
                                                label: <span style={{ color: '#30C118' }}>Final Approved</span>,
                                                value: 'FINAL APPROVED'
                                            },
                                            {
                                                label: <span style={{ color: '#2C2B2B' }}>Reimbursement</span>,
                                                value: 'REIMBURSEMENT'
                                            },
                                            {
                                                label: <span style={{ color: '#E41212' }}>Rejected</span>,
                                                value: 'REJECTED'
                                            },
                                            {
                                                label: <span style={{ color: '#2C2B2B' }}>Others</span>,
                                                value: 'OTHERS'
                                            }
                                        ]}
                                        onChange={e => setStatus(e)}
                                        value={status}
                                    />
                                )}

                                {tabNo === 'Date' && (
                                    <>
                                    <div style={{ marginBottom: '5px' }}>
                                        <label>From</label>
                                    </div>
                                    <DatePicker className="filter-input"
                                        value={fromDate === null ? null : dayjs(fromDate)}
                                        onChange={e => {
                                            setFromDate(e)
                                        }}
                                    />
                                    <div style={{ marginBottom: '5px', marginTop: '20px' }}>
                                        <label>To</label>
                                    </div>
                                    <DatePicker className="filter-input"
                                        value={toDate === null ? null : dayjs(toDate)}
                                        onChange={e => {
                                            setToDate(e)
                                        }}
                                    />
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '20px', borderBottom: '1px solid lightgray'}}>
                        <Button
                            className='button'
                            style={{ border: '1px solid #00A82E', color: '#00A82E' }}
                            onClick={clearAllFilters}
                        >
                            Reset
                        </Button>
                        <Button
                            className='button'
                            style={{ backgroundColor: '#00A82E', color: 'white' }}
                            onClick={handleSubmit}
                        >
                            Apply
                        </Button>
                    </div>
                </Card>
            </div>
        </>
    )
}

export default Filter;